<div class="p-4 rounded-xl">

  <div class="flex items-center justify-between mb-4">
    <div class="flex items-center gap-4">
      <app-back-button></app-back-button>
      <div class="h-6 w-px bg-slate-200 mx-1"></div>
      <h2 class="text-lg font-semibold">{{ 'SETUP.GEOGRAPHY.STATE' | translate }}</h2>
    </div>

    <button class="btn-primary" (click)="openPopup()">
      {{ 'SETUP.ADD_PLUS' | translate }}
    </button>
  </div>

  <app-table
    [columns]="columns"
    [data]="list"
    [actions]="actions"
  ></app-table>

  <app-popup
    [(show)]="showPopup"
    title="SETUP.GEOGRAPHY.STATE"
    [fields]="fields"
    [data]="formData"
    [onSave]="handleSave"
    [readonly]="isViewMode"
    type="form"
  ></app-popup>

  <app-popup
    [(show)]="showDeletePopup"
    title="SETUP.GEOGRAPHY.DELETE_STATE"
    type="confirm"
    [message]="deleteMessage"
    confirmText="COMMON.DELETE"
    cancelText="COMMON.CANCEL"
    (confirmed)="confirmDelete()"
  ></app-popup>

</div>